import { InputEventDetails } from "@/types/types";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { html, LitElement, TemplateResult } from "lit";
import { property } from "lit/decorators.js";
import { BasicInputTextAreaStyles } from "../BasicInputTextareStyles";

abstract class BaseInput extends LitElement {
	static readonly styles = [BasicInputTextAreaStyles];

	@property({ type: String }) id: string;
	@property({ type: String }) helperText = "";
	@property({ type: String }) inputEventIdentifier = "";
	@property({ type: String }) label = "";
	@property({ type: String }) name = "";
	@property({ type: String }) value = "";
	@property({ type: Boolean, reflect: true }) disabled = false;

	protected createRenderRoot() {
		const root = super.createRenderRoot();
		root.addEventListener("input", this._handleInputChange);
		return root;
	}

	protected abstract renderInput(): TemplateResult;

	private readonly _handleInputChange = (event: Event) => {
		if (this.disabled) return;

		const inputComponent = event.target as HTMLInputElement | HTMLTextAreaElement;
		this.dispatchEvent(new CustomEvent<InputEventDetails>(CustomEventType.INPUT_CHANGE, {
			detail: {
				additionalIdentifier: this.inputEventIdentifier,
				label: this.label,
				name: this.name,
				value: inputComponent.value,
			},
			bubbles: true,
			composed: true
		}));
	};

	render() {
		return html`
			<div class="input-group">
				<label for="${this.id}">${this.label}</label>
				${this.renderInput()}
				${this.helperText ? html`<div class="helper-text">${this.helperText}</div>` : ''}
			</div>
		`;
	}
}

export default BaseInput;